export function getBannerCookieName(id: string): string {
    return `${id}-banner`;
}
